// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Organisation  {
    _originalTypeClassName = "Loom.BO.Organisation";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Organisation.translate = translateService;
}
this.Departments = [];
this.BankAccounts = [];
this.Facilities = [];
this.ParticipatedAffiliations = [];
this.Projects = [];
this.ParticipationAsBeneficiary = [];
this.EmploymentRelationships = [];
this.ProjectPlans = [];
this.Benefits = [];
this.Id = null;
this.ShortName = null;
this.LegalName = null;
this.BusinessName = null;
this.CreatedBy = null;
this.Email = null;
this.Description = null;
this.AddressStr = null;
this.ZipCode = null;
this.Region = null;
this.NoVAT = false;
this.VATNumber = null;
this.Telephone = null;
this.Logo = null;
this.PreferredPaymentMethod = null;
this.PIC = null;
this.City = null;
this.Website = null;
this.Telephone2 = null;
this.DisableReminders = false;
this.PersonnelCount = null;
this.LegalEntityStatus = null;
this.LegalRegisterCity = null;
this.RegistrationNumber = null;
this.RegistrationDate = null;
this.LegalEntityType = null;
this.LegalEntityQualification = null;
this.IsNGO = false;
this.IsCivilSocietyOrg = false;
this.IsInternationalOrg = false;
this.IsReseachOrg = false;
this.IsLargeResearchInstitute = false;
this.FullTimeDailyHours = 8;
this.FullTimeWeeklyHours = 40;
this.PersonnelMeanSickDays = null;
this.PersonnelMeanTrainingDays = null;
this.PersonHoursPerPersonMonth = 143.33;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
ShortName:any;
LegalName:any;
BusinessName:any;
CreatedBy:any;
Email:any;
Description:any;
AddressStr:any;
ZipCode:any;
Region:any;
NoVAT:any;
VATNumber:any;
Telephone:any;
Logo:any;
PreferredPaymentMethod:any;
PIC:any;
City:any;
Website:any;
Telephone2:any;
DisableReminders:any;
PersonnelCount:any;
LegalEntityStatus:any;
LegalRegisterCity:any;
RegistrationNumber:any;
RegistrationDate:any;
LegalEntityType:any;
LegalEntityQualification:any;
IsNGO:any;
IsCivilSocietyOrg:any;
IsInternationalOrg:any;
IsReseachOrg:any;
IsLargeResearchInstitute:any;
FullTimeDailyHours:any;
FullTimeWeeklyHours:any;
PersonnelMeanSickDays:any;
PersonnelMeanTrainingDays:any;
PersonHoursPerPersonMonth:any;
Departments:any;
Country:any;
BankAccounts:any;
Facilities:any;
ParticipatedAffiliations:any;
LogoDark:any;
LogoLight:any;
Projects:any;
ParticipationAsBeneficiary:any;
EmploymentRelationships:any;
ProjectPlans:any;
Benefits:any;
static setDepartments = ($this, items) => {
                if (items == null) items = [];
                if ($this.Departments == null) $this.Departments = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Departments.length > 0) {
                    Domain.Organisation.removeDepartments($this, $this.Departments[0]);
                }

                Domain.Organisation.addManyDepartments($this, copyItems);
            }
static addManyDepartments = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Organisation.addDepartments($this, items[i]);
                }
            }
static addDepartments = ($this, item) => {
                if ($this.Departments == null) $this.Departments = [];
                if (item == null || $this.Departments.indexOf(item) > -1) return;
                $this.Departments.push(item);
if (item.Organisation != $this) {
Domain.Department.setOrganisation(item, $this);
}
}
static addRangeDepartments = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Organisation.addDepartments($this, item));
            }
static removeDepartments = ($this, item) => {
                if ($this == null || $this.Departments == null || $this.Departments.indexOf(item) === -1) return;
                var _index = $this.Departments.indexOf(item);
                $this.Departments.splice(_index, 1);
item.Organisation = null;
}
static clearDepartments = ($this) => { $this.Departments = null; }
static setCountry = ($this, value) => {
var oldValue = $this.Country;
$this.Country = value;
if (value != null) {
}
}
static setBankAccounts = ($this, items) => {
                if (items == null) items = [];
                if ($this.BankAccounts == null) $this.BankAccounts = [];

                const copyItems = Common.cloneObject(items);

                while ($this.BankAccounts.length > 0) {
                    Domain.Organisation.removeBankAccounts($this, $this.BankAccounts[0]);
                }

                Domain.Organisation.addManyBankAccounts($this, copyItems);
            }
static addManyBankAccounts = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Organisation.addBankAccounts($this, items[i]);
                }
            }
static addBankAccounts = ($this, item) => {
                if ($this.BankAccounts == null) $this.BankAccounts = [];
                if (item == null || $this.BankAccounts.indexOf(item) > -1) return;
                $this.BankAccounts.push(item);
}
static addRangeBankAccounts = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Organisation.addBankAccounts($this, item));
            }
static removeBankAccounts = ($this, item) => {
                if ($this == null || $this.BankAccounts == null || $this.BankAccounts.indexOf(item) === -1) return;
                var _index = $this.BankAccounts.indexOf(item);
                $this.BankAccounts.splice(_index, 1);
}
static clearBankAccounts = ($this) => { $this.BankAccounts = null; }
static setFacilities = ($this, items) => {
                if (items == null) items = [];
                if ($this.Facilities == null) $this.Facilities = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Facilities.length > 0) {
                    Domain.Organisation.removeFacilities($this, $this.Facilities[0]);
                }

                Domain.Organisation.addManyFacilities($this, copyItems);
            }
static addManyFacilities = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Organisation.addFacilities($this, items[i]);
                }
            }
static addFacilities = ($this, item) => {
                if ($this.Facilities == null) $this.Facilities = [];
                if (item == null || $this.Facilities.indexOf(item) > -1) return;
                $this.Facilities.push(item);
if (item.Organisation != $this) {
Domain.Facility.setOrganisation(item, $this);
}
}
static addRangeFacilities = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Organisation.addFacilities($this, item));
            }
static removeFacilities = ($this, item) => {
                if ($this == null || $this.Facilities == null || $this.Facilities.indexOf(item) === -1) return;
                var _index = $this.Facilities.indexOf(item);
                $this.Facilities.splice(_index, 1);
item.Organisation = null;
}
static clearFacilities = ($this) => { $this.Facilities = null; }
static setParticipatedAffiliations = ($this, items) => {
                if (items == null) items = [];
                if ($this.ParticipatedAffiliations == null) $this.ParticipatedAffiliations = [];

                const copyItems = Common.cloneObject(items);

                while ($this.ParticipatedAffiliations.length > 0) {
                    Domain.Organisation.removeParticipatedAffiliations($this, $this.ParticipatedAffiliations[0]);
                }

                Domain.Organisation.addManyParticipatedAffiliations($this, copyItems);
            }
static addManyParticipatedAffiliations = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Organisation.addParticipatedAffiliations($this, items[i]);
                }
            }
static addParticipatedAffiliations = ($this, item) => {
                if ($this.ParticipatedAffiliations == null) $this.ParticipatedAffiliations = [];
                if (item == null || $this.ParticipatedAffiliations.indexOf(item) > -1) return;
                $this.ParticipatedAffiliations.push(item);
Domain.OrganizationalAffiliation.addAffiliatedOrganisations(item, $this);
}
static addRangeParticipatedAffiliations = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Organisation.addParticipatedAffiliations($this, item));
            }
static removeParticipatedAffiliations = ($this, item) => {
                if ($this == null || $this.ParticipatedAffiliations == null || $this.ParticipatedAffiliations.indexOf(item) === -1) return;
                var _index = $this.ParticipatedAffiliations.indexOf(item);
                $this.ParticipatedAffiliations.splice(_index, 1);
Domain.OrganizationalAffiliation.removeAffiliatedOrganisations(item, $this);
}
static clearParticipatedAffiliations = ($this) => { $this.ParticipatedAffiliations = null; }
static setLogoDark = ($this, value) => {
var oldValue = $this.LogoDark;
$this.LogoDark = value;
if (value != null) {
}
}
static setLogoLight = ($this, value) => {
var oldValue = $this.LogoLight;
$this.LogoLight = value;
if (value != null) {
}
}
static setProjects = ($this, items) => {
                if (items == null) items = [];
                if ($this.Projects == null) $this.Projects = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Projects.length > 0) {
                    Domain.Organisation.removeProjects($this, $this.Projects[0]);
                }

                Domain.Organisation.addManyProjects($this, copyItems);
            }
static addManyProjects = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Organisation.addProjects($this, items[i]);
                }
            }
static addProjects = ($this, item) => {
                if ($this.Projects == null) $this.Projects = [];
                if (item == null || $this.Projects.indexOf(item) > -1) return;
                $this.Projects.push(item);
if (item.Organisation != $this) {
Domain.Project.setOrganisation(item, $this);
}
}
static addRangeProjects = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Organisation.addProjects($this, item));
            }
static removeProjects = ($this, item) => {
                if ($this == null || $this.Projects == null || $this.Projects.indexOf(item) === -1) return;
                var _index = $this.Projects.indexOf(item);
                $this.Projects.splice(_index, 1);
item.Organisation = null;
}
static clearProjects = ($this) => { $this.Projects = null; }
static setParticipationAsBeneficiary = ($this, items) => {
                if (items == null) items = [];
                if ($this.ParticipationAsBeneficiary == null) $this.ParticipationAsBeneficiary = [];

                const copyItems = Common.cloneObject(items);

                while ($this.ParticipationAsBeneficiary.length > 0) {
                    Domain.Organisation.removeParticipationAsBeneficiary($this, $this.ParticipationAsBeneficiary[0]);
                }

                Domain.Organisation.addManyParticipationAsBeneficiary($this, copyItems);
            }
static addManyParticipationAsBeneficiary = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Organisation.addParticipationAsBeneficiary($this, items[i]);
                }
            }
static addParticipationAsBeneficiary = ($this, item) => {
                if ($this.ParticipationAsBeneficiary == null) $this.ParticipationAsBeneficiary = [];
                if (item == null || $this.ParticipationAsBeneficiary.indexOf(item) > -1) return;
                $this.ParticipationAsBeneficiary.push(item);
if (item.Organisation != $this) {
Domain.ProjectParticipant.setOrganisation(item, $this);
}
}
static addRangeParticipationAsBeneficiary = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Organisation.addParticipationAsBeneficiary($this, item));
            }
static removeParticipationAsBeneficiary = ($this, item) => {
                if ($this == null || $this.ParticipationAsBeneficiary == null || $this.ParticipationAsBeneficiary.indexOf(item) === -1) return;
                var _index = $this.ParticipationAsBeneficiary.indexOf(item);
                $this.ParticipationAsBeneficiary.splice(_index, 1);
item.Organisation = null;
}
static clearParticipationAsBeneficiary = ($this) => { $this.ParticipationAsBeneficiary = null; }
static setEmploymentRelationships = ($this, items) => {
                if (items == null) items = [];
                if ($this.EmploymentRelationships == null) $this.EmploymentRelationships = [];

                const copyItems = Common.cloneObject(items);

                while ($this.EmploymentRelationships.length > 0) {
                    Domain.Organisation.removeEmploymentRelationships($this, $this.EmploymentRelationships[0]);
                }

                Domain.Organisation.addManyEmploymentRelationships($this, copyItems);
            }
static addManyEmploymentRelationships = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Organisation.addEmploymentRelationships($this, items[i]);
                }
            }
static addEmploymentRelationships = ($this, item) => {
                if ($this.EmploymentRelationships == null) $this.EmploymentRelationships = [];
                if (item == null || $this.EmploymentRelationships.indexOf(item) > -1) return;
                $this.EmploymentRelationships.push(item);
if (item.Organisation != $this) {
Domain.Employee.setOrganisation(item, $this);
}
}
static addRangeEmploymentRelationships = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Organisation.addEmploymentRelationships($this, item));
            }
static removeEmploymentRelationships = ($this, item) => {
                if ($this == null || $this.EmploymentRelationships == null || $this.EmploymentRelationships.indexOf(item) === -1) return;
                var _index = $this.EmploymentRelationships.indexOf(item);
                $this.EmploymentRelationships.splice(_index, 1);
item.Organisation = null;
}
static clearEmploymentRelationships = ($this) => { $this.EmploymentRelationships = null; }
static setProjectPlans = ($this, items) => {
                if (items == null) items = [];
                if ($this.ProjectPlans == null) $this.ProjectPlans = [];

                const copyItems = Common.cloneObject(items);

                while ($this.ProjectPlans.length > 0) {
                    Domain.Organisation.removeProjectPlans($this, $this.ProjectPlans[0]);
                }

                Domain.Organisation.addManyProjectPlans($this, copyItems);
            }
static addManyProjectPlans = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Organisation.addProjectPlans($this, items[i]);
                }
            }
static addProjectPlans = ($this, item) => {
                if ($this.ProjectPlans == null) $this.ProjectPlans = [];
                if (item == null || $this.ProjectPlans.indexOf(item) > -1) return;
                $this.ProjectPlans.push(item);
if (item.Organisation != $this) {
Domain.ProjectPlan.setOrganisation(item, $this);
}
}
static addRangeProjectPlans = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Organisation.addProjectPlans($this, item));
            }
static removeProjectPlans = ($this, item) => {
                if ($this == null || $this.ProjectPlans == null || $this.ProjectPlans.indexOf(item) === -1) return;
                var _index = $this.ProjectPlans.indexOf(item);
                $this.ProjectPlans.splice(_index, 1);
item.Organisation = null;
}
static clearProjectPlans = ($this) => { $this.ProjectPlans = null; }
static setBenefits = ($this, items) => {
                if (items == null) items = [];
                if ($this.Benefits == null) $this.Benefits = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Benefits.length > 0) {
                    Domain.Organisation.removeBenefits($this, $this.Benefits[0]);
                }

                Domain.Organisation.addManyBenefits($this, copyItems);
            }
static addManyBenefits = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Organisation.addBenefits($this, items[i]);
                }
            }
static addBenefits = ($this, item) => {
                if ($this.Benefits == null) $this.Benefits = [];
                if (item == null || $this.Benefits.indexOf(item) > -1) return;
                $this.Benefits.push(item);
if (item.Organisation != $this) {
Domain.BenefitType.setOrganisation(item, $this);
}
}
static addRangeBenefits = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Organisation.addBenefits($this, item));
            }
static removeBenefits = ($this, item) => {
                if ($this == null || $this.Benefits == null || $this.Benefits.indexOf(item) === -1) return;
                var _index = $this.Benefits.indexOf(item);
                $this.Benefits.splice(_index, 1);
item.Organisation = null;
}
static clearBenefits = ($this) => { $this.Benefits = null; }

static GetAllAffiliatedEntities($this: any): any{let myorgs = [];
let allAffiliations = Joove.Common.cast(myorgs?.linq?.selectMany((a) => a?.ParticipatedAffiliations)?.toArray(), "System.Collections.List");
for (let _ia = 0; _ia < (allAffiliations == null ? 0 : allAffiliations.length); _ia++) {let a = allAffiliations[_ia];myorgs?.addRange(a?.AffiliatedOrganisations?.linq?.where((o) => o != $this)?.toArray());}
return myorgs?.linq?.distinct()?.toArray();
}
static GetPersonnelCount($this: any): any{return $this?.EmploymentRelationships?.length;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}